<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      telegramWebApp: null
    }
  },
  created() {
  },
  methods: {},
  computed: {
  },
}
</script>

<style scoped lang="scss">
* {
  background-color: #ffffff;
}
</style>
